// Phase T2.0A Prompt 3 — Admin Registration Control Center API client.
// Wraps the two new admin endpoints (pair / separate) for both event kinds.
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

function api() {
  const token = localStorage.getItem('tl_session_token');
  return axios.create({
    baseURL: `${BASE}/api`,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

const PREFIX = {
  tournament:  'admin/tournaments',
  round_robin: 'admin/round-robins',
};

export const controlCenterAPI = {
  pair: (eventKind, eventId, actorProfileId, partnerProfileId) =>
    api().post(`/${PREFIX[eventKind]}/${eventId}/entries/pair`, {
      actor_profile_id: actorProfileId,
      partner_profile_id: partnerProfileId,
    }),

  separate: (eventKind, eventId, entryId) =>
    api().post(`/${PREFIX[eventKind]}/${eventId}/entries/${entryId}/separate`),

  // P3 hardening: backend-authoritative all-or-nothing mutations.
  // Frontend submits INTENT only; backend re-reads state under lock.
  removePlayer: (eventKind, eventId, entryId, profileId) =>
    api().post(`/${PREFIX[eventKind]}/${eventId}/entries/${entryId}/remove-player`, {
      profile_id: profileId,
    }),

  assignPartner: (eventKind, eventId, actorProfileId, partnerProfileId) =>
    api().post(`/${PREFIX[eventKind]}/${eventId}/assign-partner`, {
      actor_profile_id: actorProfileId,
      partner_profile_id: partnerProfileId,
    }),
};
